import React from "react"
import Select from "react-select"
import axios from "axios"
import { useTranslation } from "react-i18next"

const SelectEntries = ({
  onChange,
  collections,
  field,
  form,
  ...inputProps
}) => {
  const { t } = useTranslation()
  const [options, setOptions] = React.useState([])

  React.useEffect(() => {
    const requests = collections.map(collection =>
      axios.get(`/api/collections/${collection}/entries?fields=id,title`)
    )
    axios.all(requests).then(
      axios.spread((...res) => {
        const entries = res.reduce((acc, item) => {
          acc = [
            ...acc,
            ...item.data.data.map(entry => ({
              value: entry.id,
              label: entry.title,
            })),
          ]
          return acc
        }, [])
        entries.sort((a, b) => a.label.localeCompare(b.label))
        setOptions(
          entries
        )
      })
    )
  }, [collections])

  return <Select
    isClearable
    options={options}
    name={field.name}
    value={
      options ? options.find(option => option.value === field.value) : ""
    }
    placeholder={t("select.placeholder")}
    noOptionsMessage={() => t("select.noOptionsMessage")}
    onChange={option => {
      const newValue = !inputProps.isMulti
        ? option?.value
        : inputProps.isMulti && option !== null
          ? option.map(item => item.value)
          : []

      form?.setFieldValue(field.name, newValue)

      if (onChange) {
        onChange(newValue)
      }
    }}
    onBlur={field.onBlur}
    {...inputProps}
  />
}
export { SelectEntries }
